import React, { FunctionComponent, PropsWithChildren } from 'react';
import { ImageBlockModel } from '../../../../services/content/articleBody/models/ImageBlockModel';
import { ArticleBlockModel } from '../../../../services/content/articleBody/models/ArticleBlockModel';
import { EditorBlockModel } from '../../../../services/content/articleBody/models/EditorBlockModel';
import { EmbedBlockModel } from '../../../../services/content/articleBody/models/EmbedBlockModel';
import { CMSBlocks } from '../../../../services/content/articleBody/enums/CMSBlocks';
import { ArticleBlock } from '../blockComponents/ArticleBlock';
import { ImageBlock } from '../blockComponents/ImageBlock';
import { EmbedBlock } from '../blockComponents/EmbedBlock';
import { EditorBlocks } from '../../../../services/content/articleBody/enums/EditorBlocks';
import { Paragraph } from '../blockComponents/ParagraphBlock';
import { Heading } from '../blockComponents/HeadingBlock';
import { List } from '../blockComponents/ListBlock';
import { Quote } from '../blockComponents/QuoteBlock';
import { AdBackground } from '../../../Ads/AdBackground';
import { GoogleAdDesktop } from '../../../Ads/GoogleAdDesktop';
import { GoogleAdMobile } from '../../../Ads/GoogleAdMobile';
import { AdsConfig } from '../../ArticleHeading/models/AdsConfig';
import { VideoBlock } from '../blockComponents/VideoBlock';
import { VideoBlockModel } from '../../../../services/content/articleBody/models/VideoBlockModel';
import FUWidgetBlock from '../blockComponents/FUWidgetBlock';
import { FUWidgetBlockModel } from '../../../../services/content/articleBody/models/FUWidgetBlockModel';

export const renderBody = (
    body: (ImageBlockModel | ArticleBlockModel | EditorBlockModel | null)[],
    adsConfig: AdsConfig[],
) => {
    if (body) {
        return (
            <>
                {body.map((block: any, idx: number) => {
                    return (
                        <AdBlockWrapper
                            key={`ad-block-wrapper-key-${JSON.stringify(block.data)}`}
                            idx={idx}
                            adsConfig={adsConfig}>
                            {renderBlock(block)}
                        </AdBlockWrapper>
                    );
                })}
            </>
        );
    }
};

const renderBlock = (
    block:
        | ImageBlockModel
        | ArticleBlockModel
        | EditorBlockModel
        | EmbedBlockModel
        | VideoBlockModel
        | FUWidgetBlockModel,
) => {
    switch (block.type) {
        case CMSBlocks.EDITOR_BLOCK: {
            return renderEditorBlock(block.data);
        }
        case CMSBlocks.ARTICLE: {
            block = block as ArticleBlockModel;
            if (block.data) {
                return <ArticleBlock key={`article-key-${block.data.content.id}`} articleBlock={block} />;
            }
            return <></>;
        }
        case CMSBlocks.IMAGE: {
            block = block as ImageBlockModel;
            if (block.data) {
                return <ImageBlock key={`image-key-${block.data.content?.id}`} imageBlock={block} />;
            }
            return <></>;
        }
        case CMSBlocks.EMBED: {
            block = block as EmbedBlockModel;
            if (block.data) {
                return <EmbedBlock key={`image-key-${block.data.content}`} embedBlock={block} />;
            }
            return <></>;
        }
        case CMSBlocks.VIDEO: {
            block = block as VideoBlockModel;
            if (block.data) {
                return <VideoBlock key={`image-key-${block.data.content}`} videoBlock={block} />;
            }
            return <></>;
        }
        case CMSBlocks.FU_WIDGET: {
            block = block as FUWidgetBlockModel;
            if (block.data) {
                return <FUWidgetBlock key={`fu-widget-key-${block.data}`} data={block.data} />;
            }
            return <></>;
        }

        default: {
            return <></>;
        }
    }
};

const renderEditorBlock = (editorBlock: any) => {
    switch (editorBlock.type) {
        case EditorBlocks.PARAGRAPH: {
            return <Paragraph key={`paragraph-key-${editorBlock.content}`} content={editorBlock.content} />;
        }
        case EditorBlocks.HEADING: {
            return <Heading key={`heading-key-${editorBlock.content}`} content={editorBlock.content} />;
        }
        case EditorBlocks.LIST: {
            return <List key={`list-key-${editorBlock.content}`} content={editorBlock.content} />;
        }
        case EditorBlocks.QUOTE: {
            return <Quote key={`quote-key-${editorBlock.content}`} content={editorBlock.content} />;
        }
    }
};

const AdBlockWrapper: FunctionComponent<PropsWithChildren<{ idx: number; adsConfig: AdsConfig[] }>> = ({
    children,
    idx,
    adsConfig,
}) => {
    const FIRST_BLOCK = 0;
    const THIRD_BLOCK = 3;
    const FIFTH_BLOCK = 6;

    const adsForBlocks = {
        [`${FIRST_BLOCK}`]: { desktop: adsConfig[0].desktop, mobile: adsConfig[0].mobile },
        [`${THIRD_BLOCK}`]: { desktop: adsConfig[1].desktop, mobile: adsConfig[1].mobile },
        [`${FIFTH_BLOCK}`]: { desktop: adsConfig[2].desktop, mobile: adsConfig[2].mobile },
    };

    if (idx === FIRST_BLOCK || idx === FIFTH_BLOCK) {
        return (
            <>
                {children}
                <div className='text-center'>
                    <AdBackground className='d-inline-block'>
                        <GoogleAdDesktop
                            className='d-none d-md-inline-block d-lg-inline-block'
                            ad={adsForBlocks[`${idx}`].desktop.ad}
                        />
                        <GoogleAdMobile
                            className='d-inline-block d-md-none d-lg-none'
                            ad={adsForBlocks[`${idx}`].mobile.ad}
                        />
                    </AdBackground>
                </div>
            </>
        );
    }

    if (idx === THIRD_BLOCK) {
        return (
            <>
                {children}
                <div className='text-center'>
                    <AdBackground className='d-none d-md-inline-block d-lg-inline-block'>
                        <GoogleAdDesktop
                            className='d-none d-md-inline-block d-lg-inline-block'
                            ad={adsForBlocks[`${idx}`].desktop.ad}
                        />
                    </AdBackground>
                    <div className='d-inline-block d-md-none d-lg-none ad-container-h600'>
                        <AdBackground className='sticky-ad'>
                            <GoogleAdMobile
                                className='d-inline-block d-md-none d-lg-none'
                                ad={adsForBlocks[`${idx}`].mobile.ad}
                            />
                        </AdBackground>
                    </div>
                </div>
            </>
        );
    }

    return <>{children}</>;
};
